import { useCallback, useState } from "react";
import { MatchableItem } from "../types";
import {
    buildInitialPaymentAmounts,
    clampPaymentAmount,
} from "./allocationHelpers";

interface Params {
    selectedItems: MatchableItem[];
    transactionAmount: number;
    currentTxLineItemMatchAmounts: ReadonlyMap<string, number>;
}

export function usePaymentAmounts({
    selectedItems,
    transactionAmount,
    currentTxLineItemMatchAmounts,
}: Params) {
    const [paymentAmounts, setPaymentAmounts] = useState<
        Record<string, number>
    >(() =>
        buildInitialPaymentAmounts(
            selectedItems,
            transactionAmount,
            currentTxLineItemMatchAmounts,
        ),
    );

    const [prevInputs, setPrevInputs] = useState({
        selectedItems,
        transactionAmount,
        currentTxLineItemMatchAmounts,
    });
    if (
        selectedItems !== prevInputs.selectedItems ||
        !Object.is(transactionAmount, prevInputs.transactionAmount) ||
        currentTxLineItemMatchAmounts !==
            prevInputs.currentTxLineItemMatchAmounts
    ) {
        setPrevInputs({
            selectedItems,
            transactionAmount,
            currentTxLineItemMatchAmounts,
        });
        setPaymentAmounts(
            buildInitialPaymentAmounts(
                selectedItems,
                transactionAmount,
                currentTxLineItemMatchAmounts,
            ),
        );
    }

    const handlePaymentChange = useCallback(
        (lineItemId: string, value: number, maxOpen: number) => {
            setPaymentAmounts((prev) => ({
                ...prev,
                [lineItemId]: clampPaymentAmount(value, maxOpen),
            }));
        },
        [],
    );

    return { paymentAmounts, handlePaymentChange };
}
